<template>
  <div class="w-full flex flex-col">
    <HeroSection />
    <WhyNowSection />
    <ProgrammeSection />
    <SpotsSection />
    <HowItWorksSection />
    <CompareSection />
    <WinWinSection />
    <ProductionSection />
    <SuisaSection />
    <FaqSection />
    <ClosingCtaSection />
  </div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import ClosingCtaSection from '@/components/landing/ClosingCtaSection.vue'
import CompareSection from '@/components/landing/CompareSection.vue'
import FaqSection from '@/components/landing/FaqSection.vue'
import HeroSection from '@/components/landing/HeroSection.vue'
import HowItWorksSection from '@/components/landing/HowItWorksSection.vue'
import ProductionSection from '@/components/landing/ProductionSection.vue'
import ProgrammeSection from '@/components/landing/ProgrammeSection.vue'
import SpotsSection from '@/components/landing/SpotsSection.vue'
import SuisaSection from '@/components/landing/SuisaSection.vue'
import WhyNowSection from '@/components/landing/WhyNowSection.vue'
import WinWinSection from '@/components/landing/WinWinSection.vue'
import { useUserStore } from '@/stores/UserStore'

const router = useRouter()
const userStore = useUserStore()

// Persisted stores are empty during SSR, so the logged-in check has to wait for
// hydration — branching in the template would mismatch.
onMounted(() => {
  if (userStore.isLoggedIn) router.replace({ name: 'dashboard' })
})
</script>
